import dayjs from "dayjs";
import { useEffect, useState } from "react";
import "./PortfolioPage.scss";

import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createAgencyUser, updatePortfolio } from "../../assets/api/agency";
import { downloadPortfolioFile, uploadCSV } from "../../assets/api/portfolio";
import { AddCallScript } from "../../assets/api/ScriptsService";
import AddScriptModal from "../../components/CallScriptComp/AddScriptModal/AddScriptModal";
import PortfolioModal from "../../components/PortfolioComp/PortfolioModal/PortfolioModal";
import PortfolioTable from "../../components/PortfolioComp/PortfolioTable/PortfolioTable";
import CustomNotification from "../../Reuseable/CustomNotification/CustomNotification";
import NormalButton from "../../Reuseable/NormalButton/NormalButton";
import { fetchPortfolios } from "../../store/portfolioSlice";
import { ExportDateWiseModal } from "../../components/ExportModal/ExportModal";
import CustomSelect from "../../Reuseable/Select/Select";
import axios from "axios";

const PortfolioPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const { token } = useSelector((state) => state.auth);
  const [openDatewiseExportModal, setOpenDatewiseExportModal] = useState(false);
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);
  const [loadingExport, setLoadingExport] = useState(null);
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();

  const { portfolios, loading } = useSelector((state) => state?.portfolio);
  const dispatch = useDispatch();

  // Wizard state
  const [isScriptModalOpen, setIsScriptModalOpen] = useState(false);
  const [createdPortfolioId, setCreatedPortfolioId] = useState(null);
  const [createdPortfolioName, setCreatedPortfolioName] = useState("");
  const [scriptFormValues, setScriptFormValues] = useState(null);
  const [isAddingScript, setIsAddingScript] = useState(false);

  const [companies, setCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);

  useEffect(() => {
    dispatch(fetchPortfolios());
  }, [dispatch]);

  const fetchCompanies = async () => {
    if (!token) return;
    try {
      const response = await axios.get("portfolio/companies/", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = response.data?.data;
      if (data && Array.isArray(data?.companies)) {
        setCompanies(data?.companies);
      }
    } catch (error) {
      console.error("Failed to fetch companies", error);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, [token]);

  const handleCompanySelect = (val) => {
    setSelectedCompanyId(val);
    dispatch(fetchPortfolios(val));
  };

  const handleCreatePortfolio = async (user) => {
    const { name, total_tos, totalPOS, totalCases, company_id } = user;
    let res;
    setLoad(true);
    try {
      if (user?.is_edit) {
        res = await updatePortfolio(
          {
            payload: {
              name,
              total_cases: totalCases,
              total_pos: totalPOS,
              total_tos: total_tos,
              company_id: company_id,
            },
            portfolio_id: user?.id,
          },
          token,
        );

        if (res?.status === 200) {
          toast.success("Portfolio updated");
          if (file !== null) {
            await uploadCSV(
              {
                portfolio: user?.id,
                file: file?.[0]?.originFileObj,
              },
              token,
            );
          }
          dispatch(fetchPortfolios());
          setIsEditModalOpen(false);
        }
      } else if (createdPortfolioId) {
        res = await updatePortfolio(
          {
            payload: {
              name,
              total_cases: totalCases,
              total_pos: totalPOS,
              total_tos: total_tos,
              company_id: company_id,
            },
            portfolio_id: createdPortfolioId,
          },
          token,
        );

        if (res?.status === 200) {
          toast.success("Portfolio details updated");
          if (name) {
            setCreatedPortfolioName(name);
          }
          
          if (file !== null) {
            try {
              await uploadCSV(
                {
                  portfolio: createdPortfolioId,
                  file: file?.[0]?.originFileObj,
                },
                token,
              );
            } catch (uploadError) {
              CustomNotification.show(uploadError?.message || "Failed to upload CSV file", "error");
            }
          }

          dispatch(fetchPortfolios());
          setIsModalOpen(false);
          // setIsScriptModalOpen(true);
        }
      } else {
        res = await createAgencyUser(
          {
            name,
            total_cases: totalCases,
            total_pos: totalPOS,
            total_tos: total_tos,
            company_id: company_id,
          },
          token,
        );

        if (res?.status === 201) {
          const portfolioId = res?.data?.data?.portfolio?.id;
          const portfolioName = res?.data?.data?.portfolio?.name;

          toast.success(res?.data?.message);
          
          if (file !== null && portfolioId) {
            try {
              await uploadCSV(
                {
                  portfolio: portfolioId,
                  file: file?.[0]?.originFileObj,
                },
                token,
              );
            } catch (uploadError) {
              if (uploadError?.message === "Headers did not match master headers.") {
                toast.error("Headers did not match master headers.");
                navigate(`/portfolio/${portfolioName}`, {
                  state: { id: portfolioId, type: "Progressive", isFromAdd: true },
                });
                setIsModalOpen(false);
                setCreatedPortfolioId(null);
                setCreatedPortfolioName("");
                setFile(null);
                setScriptFormValues(null);
                setLoad(false);
                return;
              } else {
                CustomNotification.show(uploadError?.message || "Failed to upload CSV file", "error");
              }
            }
          }

          dispatch(fetchPortfolios());
          
          setCreatedPortfolioId(portfolioId);
          setCreatedPortfolioName(portfolioName);
          setIsModalOpen(false);
          // setIsScriptModalOpen(true);
        }
      }
    } catch (error) {
      if (error?.message === "Headers did not match master headers.") {
        const portfolioName = res?.data?.data?.portfolio?.name || user?.name || name;
        const portfolioId = res?.data?.data?.portfolio?.id || user?.id || createdPortfolioId;

        if (res?.data?.data?.portfolio?.id) {
          setCreatedPortfolioId(res.data.data.portfolio.id);
          setCreatedPortfolioName(res.data.data.portfolio.name);
        }

        navigate(`/portfolio/${portfolioName}`, {
          state: { id: portfolioId, type: user?.type, isFromAdd: !user?.is_edit },
        });
      } else {
        CustomNotification.show(error?.message, "error");
      }
    } finally {
      setLoad(false);
    }
  };

  const handleClosePortfolioModal = () => {
    setIsModalOpen(false);
    setCreatedPortfolioId(null);
    setCreatedPortfolioName("");
    setFile(null);
    setScriptFormValues(null);
  };

  const handleCancelBoth = () => {
    setIsScriptModalOpen(false);
    setCreatedPortfolioId(null);
    setCreatedPortfolioName("");
    setFile(null);
    setScriptFormValues(null);
  };

  const handleBefore = (currentScriptFormValues) => {
    setScriptFormValues(currentScriptFormValues);
    setIsScriptModalOpen(false);
    setIsModalOpen(true);
  };

  const handleSaveScript = async (values) => {
    try {
      setIsAddingScript(true);
      const res = await AddCallScript(token, values);
      if (res.status === 201 || res.status === 200) {
        CustomNotification.show("Script added successfully", "success");
        
        // Upload CSV file (if one was uploaded in Step 1)
        if (file !== null && createdPortfolioId) {
          try {
            await uploadCSV(
              {
                portfolio: createdPortfolioId,
                file: file?.[0]?.originFileObj,
              },
              token,
            );
          } catch (uploadError) {
            if (uploadError?.message === "Headers did not match master headers.") {
              toast.error("Headers did not match master headers.");
              navigate(`/portfolio/${createdPortfolioName}`, {
                state: { id: createdPortfolioId, type: "Progressive", isFromAdd: true },
              });
              
              // Clear states
              setIsScriptModalOpen(false);
              setCreatedPortfolioId(null);
              setCreatedPortfolioName("");
              setFile(null);
              setScriptFormValues(null);
              return;
            } else {
              CustomNotification.show(uploadError?.message || "Failed to upload CSV file", "error");
            }
          }
        }

        setIsScriptModalOpen(false);
        setCreatedPortfolioId(null);
        setCreatedPortfolioName("");
        setFile(null);
        setScriptFormValues(null);
      }
    } catch (error) {
      CustomNotification.show(error || "Failed to add script", "error");
    } finally {
      setIsAddingScript(false);
    }
  };
  
  const showModal = () => {
    setIsModalOpen(true);
  };

  /* `portfolio` is passed explicitly by the row's export presets: they fire in
     the same tick as the selection, so reading selectedPortfolio from state
     would still see the previous row. Falls back to state for the modal. */
  const handleExport = async (params = {}, portfolio = selectedPortfolio) => {
    if (!portfolio?.id) return;

    try {
      setLoadingExport(portfolio.id);

      const res = await downloadPortfolioFile(token, {
        ...params,
        portfolio_id: portfolio.id,
      });

      if (res?.status === 200) {
        const downloadUrl = res?.data?.data?.download_url;

        if (downloadUrl) {
          // 🔽 Trigger browser download
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", ""); // optional, browser decides filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } else {
        toast.error(res?.message || "Failed to export cases");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingExport(null);
    }
  };

  return (
    <div className="portfolioPageMainWrapper">
      <div className="portfolioPageMain">
        <div className="portfolioPageMainHeader">
          <h2>All Portfolios</h2>
          {!loading && (
            <span className="portfolioCount">{portfolios?.length ?? 0}</span>
          )}
        </div>
        <div className="portfolioPageMainSegment">
          {/* has-value keeps the clear cross on screen while a company is
              selected - antd only reveals it on hover, so there was nothing
              to tell you the filter could be dropped. */}
          <div
            className={`portfolioCompanyFilter${
              selectedCompanyId ? " has-value" : ""
            }`}
          >
            <CustomSelect
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={companies.map(c => ({ value: c.id, label: c.name }))}
              value={selectedCompanyId}
              onChange={handleCompanySelect}
              placeholder="Filter by Company"
              /* a plain cross rather than antd's filled circle-x, so it can
                 sit in the brand chip below */
              allowClear={{ clearIcon: <CloseOutlined /> }}
            />
          </div>
          <NormalButton
            className="addPortfolioBtn"
            onClick={showModal}
            type="primary"
            suffixIcon={<PlusOutlined />}
          >
            Add Portfolio
          </NormalButton>
        </div>
      </div>

      {/* Show modal if open */}
      <PortfolioModal
        isOpen={isModalOpen}
        onClose={handleClosePortfolioModal}
        onSave={handleCreatePortfolio}
        mode="add"
        load={load}
        setFile={setFile}
        file={file}
        keepFormValues={createdPortfolioId !== null}
      />
      {/* <AddScriptModal
        isOpen={isScriptModalOpen}
        onClose={handleCancelBoth}
        onSave={handleSaveScript}
        load={isAddingScript}
        onBefore={handleBefore}
        isWizard={true}
        initialPortfolioId={createdPortfolioId}
        initialPortfolioName={createdPortfolioName}
        initialValues={scriptFormValues}
      /> */}
      <div className="portfolioContent">
        <PortfolioTable
          setSelectedItem={setSelectedPortfolio}
          setOpenDatewiseExportModal={setOpenDatewiseExportModal}
          file={file}
          data={loading ? Array(5).fill({}) : portfolios}
          loading={loading}
          setFile={setFile}
          handleCreatePortfolio={handleCreatePortfolio}
          load={load}
          isEditModalOpen={isEditModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
          handleExport={handleExport}
          loadingExport={loadingExport}
        />
      </div>
      <ExportDateWiseModal
        loadingExport={loadingExport}
        data={selectedPortfolio}
        open={openDatewiseExportModal}
        setOpen={setOpenDatewiseExportModal}
        handleExport={handleExport}
      />
    </div>
  );
};

export default PortfolioPage;